import React from "react";

import noiseBg from "../../../images/team/noice-bg.png";

import img01 from "../../../images/team/img01.jpg";
import img02 from "../../../images/team/img02.jpg";
import img03 from "../../../images/team/img03.jpg";
import img04 from "../../../images/team/img04.jpg";
import img05 from "../../../images/team/img05.jpg";
import img06 from "../../../images/team/img06.jpg";
import img07 from "../../../images/team/img07.jpg";
import img08 from "../../../images/team/img08.jpg";

const teamMembers = [
  { name: "Rizky Pratama",    role: "CEO & Co-Founder",              img: img01 },
  { name: "Aditya Nugraha",   role: "CTO & Co-Founder",              img: img02 },
  { name: "Sinta Dewi",       role: "Head of AI & Machine Learning", img: img03 },
  { name: "Bima Santoso",     role: "Head of Compliance & Risk",     img: img04 },
  { name: "Nadia Kusuma",     role: "VP of Product",                 img: img05 },
  { name: "Farhan Hidayat",   role: "Lead Biometrics Engineer",      img: img06 },
  { name: "Tiara Wulandari",  role: "Head of Partnerships",          img: img07 },
  { name: "Galih Ramadhan",   role: "Senior Backend Engineer",       img: img08 },
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150"
      style={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)" }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Our Team</span>
          <h2 className="title title-line_height">The people behind TrustEngine</h2>
        </div>

        <div className="row mt-none-55">
          {teamMembers.map((member, i) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-55"
              key={i}
            >
              <div className="xb-team-item xb-border">
                <div className="xb-item--img">
                  <img src={member.img} alt={member.name} />
                </div>

                <div className="xb-item--holder ul_li_between">
                  <div className="xb-item--author">
                    <h2 className="xb-item--name">{member.name}</h2>
                    <span className="xb-item--desig">{member.role}</span>
                  </div>
                  <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="xb-item--social xb-border"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </div>

                <div className="xb-bg">
                  <img src={noiseBg} alt="background texture" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
